import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import UiKitButton from 'components/UiKit/Button';
import CropZoneIcon from 'assets/crop_zone_primary.svg';
import SelectPropertiesDrawerV2 from 'components/SelectPropertiesDrawerV2';
import useLoadsFilterSelectionAdapter from './hooks/useLoadsFilterSelectionAdapter';

const SelectPropertiesFilter = ({ hideClearButton = false }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const count = values?.cropZones?.length || 0;
  const selectionAdapter = useLoadsFilterSelectionAdapter();

  const onReset = () => {
    setFieldValue('cropZones', []);
    setFieldValue('totalAcres', null);
    setFieldValue('totalArea', null);
    setFieldValue('sources', []);
    setFieldValue('sourceType', null);
  };

  return (
    <>
      <div className="flex justify-center gap-4">
        <UiKitButton
          ghost
          variant="primary"
          onClick={() => setOpenDrawer(true)}
          icon={<img src={CropZoneIcon} alt="cropzone icon" />}
        >
          Select Properties
        </UiKitButton>
        {!hideClearButton && (
          <UiKitButton variant="outline" onClick={onReset} disabled={!count}>
            Clear Selections
          </UiKitButton>
        )}
      </div>
      {openDrawer && (
        <SelectPropertiesDrawerV2
          open
          onClose={() => setOpenDrawer(false)}
          selectionAdapter={selectionAdapter}
        />
      )}
    </>
  );
};

SelectPropertiesFilter.propTypes = {
  hideClearButton: PropTypes.bool
};

export default SelectPropertiesFilter;
